import * as API from "@/services/API";

export default {
    // Sales & Stock report for one manufacturer (company) over a date range.
    getSalesStockReport(company_id, from, to) {
        return API.apiClient.get('/api/reports/sales-stock', {
            params: { company_id, from, to },
        });
    },
};
